import type { ProductEntity } from '@/entities/assortment'
import type { InterpretationStepModel } from '@/entities/optimization-statistic'

import fastEq from 'fast-deep-equal'

import { formatNumber, NumberFormats } from '@/shared/tools/locale'

export const isProductEntity = (data: any): data is ProductEntity =>
	'sku' in data

export const isChanged = (localData = {}, nativeData = {}) =>
	!fastEq({ ...nativeData, ...localData }, nativeData)

export const getGroupSteps = (
	interpretation: InterpretationStepModel[],
	key: string
): InterpretationStepModel[] =>
	interpretation.filter(({ ui_group }) => ui_group === key)

export const getPriceLabel = (ranges: (number | null)[]) =>
	ranges
		?.map((value) =>
			value !== null ? formatNumber(value, NumberFormats.Fixed) : '∞'
		)
		.join(' - ')
